const cancelLocalWorryNotification: () => void = (window as any)
    .cancelLocalWorryNotification;
const closeApp: () => void = (window as any).closeApp;

const closeThermometer: () => void = (window as any).closeThermometer;
const continueOnboardingFlow: () => void = (window as any)
    .continueOnboardingFlow;
const thermometerOverviewBackPressed: () => void = (window as any)
    .thermometerOverviewBackPressed;
const hideTabBar: () => void = (window as any).hideTabBar;
const showTabBar: () => void = (window as any).showTabBar;
const openEvaluation: () => void = (window as any).openEvaluation;
const openLogbook: () => void = (window as any).openLogbook;
const scheduleLocalWorryNotification: (hour: number, minute: number) => void = (
    window as any
).scheduleLocalWorryNotification;

const scheduleWeeklyCheckInNotification: (
    hour: number,
    minute: number,
    dayOfWeek: number,
) => void = (window as any).scheduleWeeklyCheckInNotification;

const cancelWeeklyCheckInNotification: () => void = (window as any)
    .cancelWeeklyCheckInNotification;

export {
    cancelLocalWorryNotification,
    closeApp,
    continueOnboardingFlow,
    thermometerOverviewBackPressed,
    hideTabBar,
    showTabBar,
    openEvaluation,
    openLogbook,
    scheduleLocalWorryNotification,
    scheduleWeeklyCheckInNotification,
    cancelWeeklyCheckInNotification,
    closeThermometer,
};
